import { useEffect, useState } from "react"
import { storyblokEditable, renderRichText } from "@storyblok/react"
import { motion, AnimatePresence } from "framer-motion"

export default function AreYouACoach({ blok }: any) {
  const [index, setIndex] = useState(0)

  const rawHTML = renderRichText(blok.items || { content: [] }) || ""
  const plainText = rawHTML.replace(/<\/?[^>]+(>|$)/g, "")
  const sentences = plainText
    .split("•")
    .map((line) => line.trim())
    .filter(Boolean)

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % sentences.length)
    }, 3000)
    return () => clearInterval(interval)
  }, [sentences.length])

  return (
    <section
      {...storyblokEditable(blok)}
      className="py-32 px-6 md:px-20 bg-white relative"
    >
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-start">
        <div>
          <div
            className="font-['BeausiteClassic'] font-bold text-[26px] md:text-[36px] text-gray-900 mb-4"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.heading || { content: [] }) || "",
            }}
          />
          <div className="block md:hidden font-['BeausiteClassic'] font-bold italic text-[#4750F5] text-xl md:text-2xl mb-6 min-h-[2.5rem]">
            <AnimatePresence mode="wait">
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.6 }}
              >
                {sentences[index]}
              </motion.div>
            </AnimatePresence>
          </div>
          <div
            className="font-['BeausiteClassic'] text-base md:text-lg text-gray-700 leading-relaxed max-w-xl"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.description || { content: [] }) || "",
            }}
          />
        </div>
        <div className="hidden md:flex items-start justify-end mt-[2px]">
          <div className="font-['BeausiteClassic'] font-bold italic text-[#4750F5] text-[28px] min-h-[2.5rem]">
            <AnimatePresence mode="wait">
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.6 }}
              >
                {sentences[index]}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  )
}
